import React, { useEffect } from 'react';
import ReactRouterPropTypes from 'react-router-prop-types';
import { Helmet } from 'react-helmet';
import { useParams, useLocation } from 'react-router-dom';
import { useViewlogies } from 'context';
import Loader from 'components/Loader';
import Viewlogy from './Viewlogy';
import Redirect404 from 'features/Redirect404';
import queryString from 'query-string';

/**
 * Container component for Viewlogies event page
 * @param {Object} match - ReactRouter URL match object
 * @return {JSX.Element}
 * @constructor
 */
const ViewlogyContainer = () => {
    const params = useParams();
    const location = useLocation();

    const queryPin = queryString.parse(location.search).pin; // retrieves pin from query string
    const { fetchEvent, isLoading, event } = useViewlogies();
    // fetch event data from API
    useEffect(() => {
        (async () => fetchEvent(params))();
    }, []);
    // return loading animation while loading
    if (isLoading) return <Loader />;
    // Check hideFromPortal field - do not populate video page if true
    if (event && event.hideFromPortal === true) {
        return (
            <>
                <Helmet>
                    <meta name="robots" content="noindex, nofollow" />
                </Helmet>
                <Redirect404 />
            </>
        );
    }
    // return Viewlogies event page
    return <Viewlogy pin={queryPin} />;
};

export default ViewlogyContainer;
